import {
  DIRECT_TO_HOME,
  FIELD_SALES,
  FUSION_CLOSER,
  INSIDE_SALES,
  UserProfile,
  getSplatUserType,
} from "@sunrun/sales-experience-shared";

type NewDashboardOrgType = "BLOCK" | "STREET" | "CHAIN" | "AIR" | "UNKNOWN";

const getNewDashboardOrgType = (
  userProfile: UserProfile | undefined
): NewDashboardOrgType => {
  if (!userProfile) {
    return "UNKNOWN";
  }
  const splatUserType = getSplatUserType(userProfile);
  switch (splatUserType) {
    case FUSION_CLOSER:
      return "BLOCK";
    case DIRECT_TO_HOME:
      return "STREET";
    case FIELD_SALES:
      return "CHAIN";
    case INSIDE_SALES:
      return "AIR";
    default:
      return "UNKNOWN";
  }
};

export type { NewDashboardOrgType };
export { getNewDashboardOrgType };
